module.exports = __webpack_public_path__ + "img/javascript.0771abe4.svg";